import { Button, Group, Select, TextInput } from '@mantine/core'
import { IconSearch } from '@tabler/icons-react'

export type SearchFilterValues = {
  q: string
  action: string
  from: string
  to: string
  traceStatus: string
}

const ACTION_OPTIONS = [
  { value: '', label: 'All actions' },
  { value: 'DELETE', label: 'DELETE' },
  { value: 'MERGE', label: 'MERGE' },
  { value: 'UPDATE_URL', label: 'UPDATE_URL' },
  { value: 'FLAG_FOR_REVIEW', label: 'FLAG_FOR_REVIEW' },
  { value: 'CHECK_DUPLICATE_PAIR', label: 'CHECK_DUPLICATE_PAIR' },
  { value: 'none', label: 'No action' },
]

const TRACE_STATUS_OPTIONS = [
  { value: '', label: 'All statuses' },
  { value: 'in_progress', label: 'In progress' },
  { value: 'done', label: 'Done' },
  { value: 'failed', label: 'Failed' },
]

type Props = {
  values: SearchFilterValues
  onChange: (values: SearchFilterValues) => void
  onSearch: () => void
  loading?: boolean
}

export const SearchFilters = ({ values, onChange, onSearch, loading }: Props) => {
  const set = (key: keyof SearchFilterValues, value: string) =>
    onChange({ ...values, [key]: value })

  return (
    <Group align='flex-end' wrap='wrap' mb='md'>
      <TextInput
        label='Search'
        placeholder='Company name, domain, or HubSpot ID'
        value={values.q}
        onChange={(e) => set('q', e.currentTarget.value)}
        leftSection={<IconSearch size={16} />}
        style={{ flex: '1 1 280px' }}
        onKeyDown={(e) => e.key === 'Enter' && onSearch()}
      />
      <Select
        label='Action'
        data={ACTION_OPTIONS}
        value={values.action}
        onChange={(value) => set('action', value ?? '')}
        clearable={false}
        style={{ flex: '0 1 180px' }}
      />
      <Select
        label='Trace status'
        data={TRACE_STATUS_OPTIONS}
        value={values.traceStatus}
        onChange={(value) => set('traceStatus', value ?? '')}
        clearable={false}
        style={{ flex: '0 1 160px' }}
      />
      <TextInput
        label='From'
        type='date'
        value={values.from}
        onChange={(e) => set('from', e.currentTarget.value)}
        style={{ flex: '0 1 150px' }}
      />
      <TextInput
        label='To'
        type='date'
        value={values.to}
        onChange={(e) => set('to', e.currentTarget.value)}
        style={{ flex: '0 1 150px' }}
      />
      <Button onClick={onSearch} loading={loading}>
        Search
      </Button>
    </Group>
  )
}
